<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.search_information = ''
          active = false
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin tìm kiếm</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.search_information"
                    type="text"
                    placeholder="Nhập thông tin"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.is_active"
                  placeholder="Vui lòng chọn"
                >
                  <!-- @change="attachData" -->
                  <el-option label="Tất cả" value=""> </el-option>
                  <el-option label="Đang hoạt động" :value="true"> </el-option>
                  <el-option label="Không hoạt động" :value="false">
                  </el-option>
                </el-select>
              </div>

              <!-- <div class="das-form-input">
              <div class="label">Thông tin tìm kiếm</div>
              <div class="child-w-80">
                <input type="text" placeholder="Nhập thông tin">
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        :auto-select-first-row="false"
        :auto-size-cell="true"
        @refresh="onRefresh"
        @selectionChanged="selectionChangedUser"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <!-- <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteGroupUser"
      >
        {{ $t('button.delete') }}
      </button> -->
      <button
        :disabled="isDisableModify || disabledByLongTask"
        class="btn primary small"
        @click="updateView"
      >
        <span v-if="disabledByLongTask" class="load"></span>
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>

      <button class="btn primary small" @click="resetPassView">
        {{ $t('button.resetPassword') }}
      </button>
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="dialogFormVisible = true">
        Thêm nhóm người dùng
      </el-button>
      <el-button type="danger" @click="deleteGroupUser">
        Xóa nhóm người dùng
      </el-button>
    </el-col> -->
    <el-dialog
      :title="!isEdit ? 'Thêm người dùng' : 'Sửa người dùng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="over-inherit"
      width="700"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">ID Nhân viên</div>
                  <validation-provider
                    rules="required|max:50|no_special"
                    name="ID Nhân viên"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên đăng nhập</div>
                  <validation-provider
                    rules="required|max:30"
                    name="Tên đăng nhập"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.username"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Họ và tên</div>
                  <validation-provider rules="required|max:50" name="Họ và tên">
                    <div class="child-w-80">
                      <input v-model="form.full_name" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Email</div>
                  <validation-provider rules="max:100|email" name="Email">
                    <div class="child-w-80">
                      <input v-model="form.email" type="email" />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div v-if="!isEdit" class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mật khẩu</div>
                  <validation-provider
                    rules="required|max:255|min:8"
                    name="Mật khẩu"
                  >
                    <div class="child-w-80">
                      <!-- <input v-model="form.password" type="password" /> -->
                      <input
                        v-if="!isShowPass"
                        v-model="form.password"
                        type="password"
                      />
                      <input v-else v-model="form.password" type="text" />
                      <span
                        v-if="!isShowPass"
                        class="input-show-password"
                        @click="isShowPass = !isShowPass"
                      />
                      <span
                        v-else
                        class="input-hide-password"
                        @click="isShowPass = !isShowPass"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Xác nhận mật khẩu</div>
                  <validation-provider
                    rules="required|max:255|min:8"
                    name="Xác nhận mật khẩu"
                  >
                    <div class="child-w-80">
                      <input
                        v-if="!isShowPassConfirm"
                        v-model="form.confirm_password"
                        type="password"
                      />
                      <input
                        v-else
                        v-model="form.confirm_password"
                        type="text"
                      />
                      <span
                        v-if="!isShowPassConfirm"
                        class="input-show-password"
                        @click="isShowPassConfirm = !isShowPassConfirm"
                      />
                      <span
                        v-else
                        class="input-hide-password"
                        @click="isShowPassConfirm = !isShowPassConfirm"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Số điện thoại</div>
                  <validation-provider
                    rules="max:20|phone"
                    name="Số điện thoại"
                  >
                    <input
                      v-model="form.phone_number"
                      v-numeric-only
                      type="number"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày bắt đầu</div>
                  <validation-provider rules="" name="Ngày bắt đầu">
                    <div class="child-w-80">
                      <SingleCalendar
                        v-model="form.time_start"
                        class="use-icon"
                        :min-max="minDate"
                        :date-data="form.time_start"
                        @input="onChangeDateStart"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Ngày hết hạn</div>
                  <validation-provider rules="" name="Ngày hết hạn">
                    <div class="child-w-80">
                      <SingleCalendar
                        v-model="form.time_expired"
                        class="use-icon"
                        :min-max="
                          form.time_start ? { min: form?.time_start } : minDate
                        "
                        :date-data="form.time_expired"
                        @input="onChangeDate"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Bộ phận</div>
                  <validation-provider rules="" name="Bộ phận">
                    <select-with-search-table
                      style="width: 100%"
                      :rows="departmentOptions"
                      :columns="columnsDepartment"
                      :dropdown-width="400"
                      :selected-index-field-value="form.department_id"
                      index-field="id"
                      :multiple="true"
                      @selectionChanged="onSelectRowDepartment"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <span>{{
                          selectedData?.length > 0
                            ? selectedData.map(item => item.name).join(', ')
                            : ''
                        }}</span>
                        <!-- {{ selectedData?.name }} {{ selectedData?.code }} -->
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Nhóm người dùng</div>
                  <validation-provider rules="" name="Nhóm người dùng">
                    <select-with-search-table
                      style="width: 100%"
                      :rows="userGroupOptions"
                      :columns="columnsUserGroup"
                      :dropdown-width="400"
                      :selected-index-field-value="form.user_group_id"
                      :multiple="true"
                      index-field="id"
                      @selectionChanged="onSelectRowUserGroup"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <span>{{
                          selectedData?.length > 0
                            ? selectedData.map(item => item.name).join(', ')
                            : ''
                        }}</span>
                        <!-- {{ selectedData?.name }} {{ selectedData?.code }} -->
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">ID thẻ nhân viên</div>
                  <validation-provider rules="" name="ID thẻ nhân viên">
                    <div style="position: relative; cursor: pointer">
                      <input v-model="form.id_card" disabled type="text" />
                      <div
                        style="
                          position: absolute;
                          left: 0;
                          right: 0;
                          top: 0;
                          bottom: 0;
                        "
                        @click="openCardReaderDialog"
                      ></div>
                    </div>

                    <!-- <button
                      class="btn primary small"
                      @click="openCardReaderDialog"
                    >
                      Đọc thẻ
                    </button> -->
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Tên phương tiện</div>
                  <validation-provider
                    rules="max:30"
                    name="Tên phương tiện"
                  >
                    <input
                      v-model="form.vehicle" type="text"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Biển kiểm soát</div>
                  <validation-provider
                    rules="max:30"
                    name="Biển kiểm soát"
                  >
                    <input
                      v-model="form.license_plate" type="text"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>

                  <el-switch
                    v-model="form.is_active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateGroupUser"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addGroupUser">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Đọc thẻ"
      :visible.sync="cardReaderDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">Vui lòng đưa thẻ vào đầu đọc</div>
                <div class="child-w-80 align-center">
                  <img height="300px" src="@/assets/images/nfc_reader.png" />
                </div>
                <input
                  ref="hidden_id_card_inp"
                  v-model="cardNum"
                  style="opacity: 0; height: 0px"
                  type="text"
                  @change="handleChangeCardNumber"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="cardReaderDialog = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="Đặt lại mật khẩu"
      :visible.sync="dialogFormVisiblePassword"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidatorReset">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Tên đăng nhập</div>

                  <div class="child-w-80">
                    <input
                      v-model="formReset.username"
                      type="text"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mật khẩu mới</div>

                  <div class="child-w-80">
                    <validation-provider
                      rules="required|max:255|min:8"
                      name="Mật khẩu"
                    >
                      <input
                        v-if="!isShowPassReset"
                        v-model="formReset.new_password"
                        type="password"
                      />
                      <input
                        v-else
                        v-model="formReset.new_password"
                        type="text"
                      />
                      <span
                        v-if="!isShowPassReset"
                        class="input-show-password"
                        @click="toggleShowReset"
                      />
                      <span
                        v-else
                        class="input-hide-password"
                        @click="toggleShowReset"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small"
            @click="dialogFormVisiblePassword = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small outline" @click="resetPassword">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders'
import {
  getUserApi,
  addUserApi,
  deleteUserApi,
  updateUserApi,
  resetPasswordApi
} from '@/api/userConfig/user'
import { getUserGroupApi } from '@/api/userConfig/userGroup'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getDepartmentApi } from '@/api/userConfig/department'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import { Message } from 'element-ui'
import {
  updateCardForStaff,
  executeCardRoomBeforeDeleteAccount
} from '@/api/reception/card_service'
import { checkRunningTask } from '@/api/task'
export default {
  components: {
    CellRenderToggleSwitchReadOnly,
    SingleCalendar,
    SelectWithSearchTable
  },
  data() {
    return {
      minDate: {
        min: this.$moment().format('YYYY-MM-DD'),
        max: null
      },
      isDisableDelete: true,
      isDisableModify: true,
      isShowPassReset: false,
      isShowPass: false,
      isShowPassConfirm: false,
      loading: false,
      active: false,
      formResetDefault: {
        username: '',
        new_password: ''
      },
      formReset: {
        username: '',
        new_password: ''
      },
      defaultForm: {
        code: '',
        username: '',
        password: '',
        is_active: true,
        last_online_time: '',
        email: '',
        phone_number: '',
        time_expired: '',
        time_start: '',
        department_id: [],
        cashier_account: 1,
        id_card: '',
        full_name: '',
        confirm_password: '',
        user_group_id: [],
        access_not_permission: false,
        notice: false,
        vehicle: '',
        license_plate: ''
      },
      form: {
        code: '',
        username: '',
        password: '',
        is_active: true,
        last_online_time: '',
        email: '',
        phone_number: '',
        time_expired: '',
        time_start: '',
        department_id: [],
        cashier_account: 1,
        id_card: '',
        full_name: '',
        confirm_password: '',
        user_group_id: [],
        access_not_permission: false,
        notice: false,
        vehicle: '',
        license_plate: ''
      },
      titlePopup: 'Thêm người dùng',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      dialogFormVisiblePassword: false,
      searchParams: {
        page_size: 10,
        page_num: 1,
        search_information: '',
        is_active: true,
        level: true
      },
      departmentOptions: [],
      cashierOptions: [],
      userGroupOptions: [],
      columnsUserGroup: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Tên nhóm',
          field: 'name',
          sortable: false,
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          sortable: false,
          field: 'desc',
          flex: 1
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      columnsDepartment: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Mã bộ phận',
          field: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Tên bộ phận',
          field: 'name',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'ID Nhân viên',
          field: 'code',
          minWidth: 150
          // width: 100
        },
        {
          headerName: 'Tên đăng nhập',
          field: 'username',
          minWidth: 150
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name',
          minWidth: 150

          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Bộ phận',
          field: 'department_name',
          minWidth: 150

          // cellRenderer: 'CellRenderTextInput',
        },

        {
          headerName: 'Nhóm người dùng',
          field: 'user_group_name',
          minWidth: 150

          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: 'Ngày bắt đầu',
          field: 'time_start',
          // cellRenderer: 'CellRenderTextInput',
          maxWidth: 120,
          minWidth: 120
        },
        {
          headerName: 'Ngày hết hạn',
          field: 'time_expired',
          // cellRenderer: 'CellRenderTextInput',
          maxWidth: 120,
          minWidth: 120
        },

        {
          headerName: 'Hoạt động',
          field: 'is_active',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.is_active
            }
          },
          maxWidth: 100,
          minWidth: 100
          // cellRenderer: 'CellRenderTextInput',
        }
        // {
        //   headerName: 'Đơn vị',
        //   field: 'name',
        //   // cellRenderer: 'CellRenderTextInput',
        //   cellClass: 'grid-cell-centered'
        // },
        // {
        //   headerName: 'Quyền App Foilo',
        //   field: 'name',

        //   // cellRenderer: 'CellRenderTextInput',
        //   cellClass: 'grid-cell-centered'
        // }
      ],
      rows: [],
      cardReaderDialog: false,
      cardNum: null,

      oldCardNum: null,
      disabledByLongTask: false
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    },
    dialogFormVisiblePassword() {
      this.dialogFormVisiblePassword ? null : this.resetItemPassword()
    }
  },
  created() {
    this.getDepartment()
    this.getUserGroup()
  },

  mounted() {
    this.attachData()
  },
  methods: {
    handleChangeCardNumber() {
      this.form.id_card = this.cardNum
      this.cardReaderDialog = false
    },
    toggleShowReset() {
      this.isShowPassReset = !this.isShowPassReset
    },
    changeActiveSearch() {
      if (this.$refs.checkboxSearch.checked) {
        delete this.searchParams.is_active
        this.searchParams = { ...this.searchParams }
      } else {
        Object.assign(this.searchParams, { is_active: true })
        this.searchParams = { ...this.searchParams }
      }
    },
    checkDatesValid(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        return false
      }

      return true
    },
    onChangeDate(val) {
      this.form.time_expired = val
      if (!this.checkDatesValid(this.form.time_start, val)) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.StartDateMustBeforeEnd')
        })
        this.form.time_expired = null
      }
    },
    onChangeDateStart(val) {
      this.form.time_start = val
      if (!this.checkDatesValid(val, this.form.time_expired)) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.StartDateMustBeforeEnd')
        })
        this.form.time_expired = null
      }
    },
    onSelectRowUserGroup(val) {
      this.form.user_group_id = val.map(item => item.id)
    },
    onSelectRowDepartment(val) {
      this.form.department_id = val.map(item => item.id)
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.page_num = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.page_size = pageSize
      this.searchParams.page_num = 1
      await this.attachData()
    },
    async getDepartment() {
      let data = await getDepartmentApi()
      this.departmentOptions = data.data
    },
    async getUserGroup() {
      let data = await getUserGroupApi({ level: true })
      this.userGroupOptions = data.data
    },
    async selectionChangedUser(rows) {
      let flag = 0
      rows.forEach(row => {
        if (row.deletable == false) {
          flag = 1
          return
        }
      })
      if (flag || rows.length == 0) this.isDisableDelete = true
      else this.isDisableDelete = false
      if (rows.length > 1 || rows.length == 0) this.isDisableModify = true
      else this.isDisableModify = false

      if (rows.length === 1) {
        this.oldCardNum = rows[0]?.id_card
        this.disabledByLongTask = await checkRunningTask(rows[0]?.id, 'STAFF')
      } else {
        this.disabledByLongTask = false
      }
    },
    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getUserApi(this.searchParams)
      // bus.$emit("endLoader");
      this.loading = false
      let accountData = data.data.map(a => a.account)
      let accountGroup = data.data.map(a => a.user_groups)
      let departmentData = accountData.map(a => a.department)

      let departmentNames = []
      departmentData.forEach(element => {
        let departmentName = element.map(a => a.code)
        departmentNames.push(departmentName.toString())
      })

      let departmentIDs = []
      departmentData.forEach(element => {
        let departmentID = element.map(a => a.id)
        departmentIDs.push(departmentID)
      })

      let userGroupIDs = []
      accountGroup.forEach(element => {
        let groupID = element.map(a => a.id)
        userGroupIDs.push(groupID)
      })
      let userGroupNames = []
      accountGroup.forEach(element => {
        let groupName = element.map(a => a.name)
        userGroupNames.push(groupName.toString())
      })

      for (let index = 0; index < accountData.length; index++) {
        let element = accountData[index]
        element = {
          ...element,
          ...{ department_name: departmentNames[index] },
          ...{ department_id: departmentIDs[index] },
          ...{ user_group_id: userGroupIDs[index] },
          ...{ user_group_name: userGroupNames[index] }
        }

        accountData[index] = element
      }
      this.rows = accountData
      this.totalPage = Math.ceil(data.total / this.searchParams.page_size)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addGroupUser() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      if (this.form.user_group_id.length == 0) {
        this.$message({
          type: 'error',
          message: 'Nhóm người dùng bắt buộc nhập'
        })
        return
      }
      if (this.form.department_id.length == 0) {
        this.$message({
          type: 'error',
          message: 'Bộ phận bắt buộc nhập'
        })
        return
      }
      if (this.form.confirm_password != this.form.password) {
        this.$message({
          type: 'error',
          message: 'Xác nhận mật khẩu không chính xác'
        })
        return
      }
      if (!this.checkDatesValid(this.form.time_start, this.form.time_expired)) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.StartDateMustBeforeEnd')
        })
        return
      }
      let data = await addUserApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateGroupUser() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      if (this.form.user_group_id.length == 0) {
        this.$message({
          type: 'error',
          message: 'Nhóm người dùng bắt buộc nhập'
        })
        return
      }
      if (this.form.department_id.length == 0) {
        this.$message({
          type: 'error',
          message: 'Bộ phận bắt buộc nhập'
        })
        return
      }

      // card room service
      if (this.form.id_card !== this.oldCardNum) {
        // call api
        const response = await updateCardForStaff({
          oldCardNumber: this.oldCardNum,
          newCardNumber: this.form.id_card,
          staffId: this.form.id
        })
        if (response?.is_error) {
          this.$message({
            type: 'error',
            message: 'Lỗi cập nhật khóa từ'
          })
        } else {
        }
      }

      let data = await updateUserApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteGroupUser() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)

      const id_card_list = rowsSelected.map(item => item.id_card)
      // card-room service: call api
      const response = await executeCardRoomBeforeDeleteAccount({
        cardNumberList: id_card_list
      })
      if (response?.is_error) {
        this.$message({
          type: 'error',
          message: 'Lỗi cập nhật khóa từ'
        })
      }

      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn người dùng!')
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá người dùng này?', () => {
          deleteUserApi(id_list)
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Bạn đã xoá người dùng thành công'
              })
              this.attachData()
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + error?.response?.data?.message)
              })
              this.dialogFormVisible = false
            })
        })
      }
    },
    async resetPassword() {
      if ((await this.$vxForm.isValid(this.$refs.formValidatorReset)) == false)
        return
      let data = await resetPasswordApi(this.formReset)
      this.dialogFormVisiblePassword = false
      this.$message({
        type: 'success',
        message: 'Bạn đã cập nhật mật khẩu thành công'
      })
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    resetPassView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 người dùng')
      } else {
        this.dialogFormVisiblePassword = true
        this.formReset.username = rowsSelected[0].username
      }
    },
    updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 người dùng để sửa')
      } else {
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form = { ...rowData }
        this.dialogFormVisible = true
      }
    },
    resetItemInfo() {
      this.form = { ...this.defaultForm }
      this.isShowPass = false
      this.isShowPassConfirm = false
    },
    resetItemPassword() {
      this.formReset = { ...this.formResetDefault }
      this.isShowPassReset = false
    },

    openCardReaderDialog() {
      this.cardNum = ''
      this.cardReaderDialog = true
      this.$nextTick(() => {
        // Focus on the input using its ref
        this.$refs.hidden_id_card_inp.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 20px;
}
.align-center {
  display: flex;
  justify-content: center;
}
</style>
